import type { CustomerFileCategory } from '@/api/portalFiles';
import { UPLOAD_GUIDANCE } from '@/lib/uploadGuidance';

/** Category guidance shown with every upload surface (wizard steps and
 *  the dashboard sections): why we need the file, the columns we
 *  usually see, and a downloadable example template where one exists. */
export function UploadGuidancePanel({ category }: { category: CustomerFileCategory }) {
  const guidance = UPLOAD_GUIDANCE[category];
  return (
    <div className="grid gap-2 rounded-md border border-brand-royal/20 bg-brand-royal/5 px-3 py-2.5 text-xs">
      <p className="text-brand-navy">{guidance.why}</p>
      {guidance.columns && (
        <p className="text-brand-slate">
          <span className="font-medium text-brand-navy">Columns we look for: </span>
          {guidance.columns.join(' · ')}
        </p>
      )}
      {guidance.formats && (
        <p className="text-brand-slate">
          <span className="font-medium text-brand-navy">Accepted formats: </span>
          {guidance.formats}
        </p>
      )}
      {guidance.templatePath && (
        <p>
          <a
            href={guidance.templatePath}
            download
            className="font-medium text-brand-royal underline-offset-4 hover:underline"
          >
            Download an example file
          </a>
          <span className="text-brand-slate"> — match its columns and you&apos;re set.</span>
        </p>
      )}
    </div>
  );
}
